import { cn } from '@plato/ui/util/classes';
import type { ReactElement } from 'react';

export type PlatoLogoProps = {
    variant?: 'dark' | 'light';
    className?: string;
};

export function PlatoLogo({ className, variant }: PlatoLogoProps): ReactElement {
    return (
        <svg
            className={cn('h-7 w-auto', variant === 'light' ? 'text-white' : 'text-[#0c0c0c]', className)}
            viewBox="0 0 220 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M43.9213 156.874C40.7971 153.75 40.7971 148.685 43.9213 145.56L103.983 85.4987C107.107 82.3745 112.172 82.3745 115.297 85.4987L175.358 145.56C178.482 148.685 178.482 153.75 175.358 156.874L115.297 216.936C112.172 220.06 107.107 220.06 103.983 216.936L43.9213 156.874Z"
                fill="currentColor"
            />
            <path
                d="M2.34314 115.296C-0.781051 112.172 -0.781046 107.107 2.34315 103.983L103.983 2.34314C107.107 -0.781052 112.172 -0.781044 115.296 2.34315L128.929 15.9762C132.054 19.1004 132.054 24.1657 128.929 27.2899L27.2899 128.929C24.1657 132.054 19.1004 132.054 15.9762 128.929L2.34314 115.296Z"
                fill="currentColor"
            />
            <path
                d="M131.929 68.8682C128.805 65.744 128.805 60.6787 131.929 57.5545L145.562 43.9214C148.686 40.7972 153.752 40.7972 156.876 43.9214L216.937 103.983C220.062 107.107 220.062 112.173 216.937 115.297L203.304 128.93C200.18 132.054 195.115 132.054 191.991 128.93L131.929 68.8682Z"
                fill="currentColor"
            />
        </svg>
    );
}
